<table [border]="0" [cellPadding]="0" [cellSpacing]="0" style="max-width: 602px; width: 100%;" align="center">
<tr>
    <td style="background-color: rgb(159, 159, 204); padding: 15px;" align="center" valign="middle">
        <h2 style="margin: 0;font-size: 30px; color: white;">
            Vips Newsletter
        </h2>
    </td>
</tr>
</table>